export const importAllImages = (imports: any): string[] => {
  return imports.keys().map(imports)
}
